(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let revealObserver;

  const reveal = (scope = document) => {
    const items = scope.querySelectorAll('[data-auvric-reveal]:not(.is-visible), .av-line-reveal:not(.is-visible), .av-image-reveal:not(.is-visible)');
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    revealObserver ||= new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7%', threshold: 0.08 });
    items.forEach((item) => revealObserver.observe(item));
  };

  const progress = (scope = document) => {
    scope.querySelectorAll('[data-shipping-progress]').forEach((bar) => {
      const total = Number(bar.dataset.cartTotal || 0);
      const threshold = Number(bar.dataset.threshold || 5000);
      bar.style.setProperty('--progress', `${Math.min(100, (total / threshold) * 100)}%`);
    });
  };

  const productEnhancements = (scope = document) => {
    const details = scope.querySelector('.product-details');
    if (!details || details.dataset.avEnhanced) return;
    details.dataset.avEnhanced = 'true';

    const variantPicker = details.querySelector('variant-picker, .variant-picker');
    const sizeLabel = [...details.querySelectorAll('legend, label, .variant-option__name')].find((node) => node.textContent.trim().toLowerCase() === 'size');
    if (sizeLabel && !sizeLabel.querySelector('.av-size-guide-link')) {
      const link = document.createElement('a');
      link.className = 'av-size-guide-link';
      link.href = '#auvric-size-guide';
      link.textContent = 'Size guide';
      sizeLabel.append(link);
    }

    const buyBlock = details.querySelector('.buy-buttons-block, buy-buttons, product-form') || variantPicker;
    if (buyBlock && !details.querySelector('.av-product-assurance')) {
      const assurance = document.createElement('div');
      assurance.className = 'av-product-assurance';
      assurance.innerHTML = '<span>Heavyweight construction</span><span>UK delivery 3–4 working days</span><span>Secure Shopify checkout</span>';
      buyBlock.insertAdjacentElement('afterend', assurance);
    }
  };

  const motionStudy = () => {
    if (reduced) return;
    const studies = document.querySelectorAll('[data-av-motion-study]');
    if (!studies.length) return;
    let ticking = false;
    const update = () => {
      studies.forEach((study) => {
        const rect = study.getBoundingClientRect();
        const range = Math.max(1, rect.height - window.innerHeight);
        const value = Math.max(0, Math.min(1, -rect.top / range));
        study.style.setProperty('--av-motion', value.toFixed(3));
      });
      ticking = false;
    };
    const request = () => {
      if (!ticking) requestAnimationFrame(update);
      ticking = true;
    };
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    request();
  };

  const buybar = () => {
    const bar = document.querySelector('[data-av-buybar]');
    const original = document.querySelector('.product-details [name="add"], .product-details button[type="submit"]');
    if (!bar || !original) return;
    const barButton = bar.querySelector('[data-av-buybar-button]');
    const price = bar.querySelector('[data-av-buybar-price]');
    const showObserver = new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }, { threshold: 0 });
    showObserver.observe(original);
    barButton.addEventListener('click', () => original.click());
    const sync = () => {
      barButton.disabled = original.disabled;
      barButton.textContent = original.disabled ? 'Unavailable' : 'Add to cart';
      const currentPrice = document.querySelector('.product-details .price, .product-details [data-product-price]');
      if (price && currentPrice) price.textContent = currentPrice.textContent.trim().replace(/\s+/g, ' ');
    };
    new MutationObserver(sync).observe(document.querySelector('.product-details'), { subtree: true, childList: true, characterData: true, attributes: true });
    sync();
  };

  const init = (scope = document) => {
    reveal(scope);
    progress(scope);
    productEnhancements(scope);
  };

  document.addEventListener('DOMContentLoaded', () => { init(); motionStudy(); buybar(); });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
